import React, { useRef, useEffect } from "react";
import {
    CONFIRMATION_DELETE_HEADER,
    CONFIRMATION_DELETE_MESSAGE,
    SPACE_NOT_ALLOWD,
    PASSWORDREGEX,
    PASSWORD_ERROR
} from "../../App.config";
import { Controller, useForm } from "react-hook-form";

const ConfirmationPasswordModalComponent = (props) => {
    const { control, register, handleSubmit, watch, formState: { errors }, reset, setValue } = useForm();
    const password = useRef({});
    password.current = watch("password", "");

    useEffect(() => {
        if (!props.modalReducer.IsOpen) {
            props.resetVerifyOtpData();
        }
    }, [props.modalReducer.IsOpen])

    return (
        <form onSubmit={handleSubmit(props.handleSubmit)}>
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">
                            {/* {props.context.t(
                            "STD.label.delete.delete-Confirmation-modal-header"
                        )} */}
                            Change Password/Modifier le mot de passe

                        </h5>
                        <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            onClick={() => props.closeRemoveModal()}
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        {/* <span>{props.context.t(
            "STD.label.delete.delete-Confirmation-modal-message"
          )}</span> */}
                        <div className="form-row">
                            <div className="form-group col-md-6">
                                <label>Password<br />
                                    /Mot de passe
                                    <span size="5" className="error-star">
                                        *
                                    </span>
                                </label>
                                <input
                                    type="password"
                                    className="form-control"
                                    placeholder="Password"
                                    name="password"
                                    {...register("password", {
                                        required: "You must specify a password", pattern: PASSWORDREGEX,
                                    })}
                                />
                                <small className="text-danger">{errors.password && <p>{errors.password.message}</p>}</small>
                                <small className="text-danger">{errors.password?.type === 'pattern' && PASSWORD_ERROR}</small>
                            </div>
                            <div className="form-group col-md-6">
                                <label>
                                    Confirm Password/Confirmer le mot de passe
                                    <span size="5" className="error-star">
                                        *
                                    </span>
                                </label>
                                <input
                                    type="password"
                                    className="form-control"
                                    placeholder="Confirm Password/Confirmer le mot de passe"
                                    name="confirmPassword"
                                    {...register("confirmPassword", {
                                        validate: value =>
                                            value === password.current || "The passwords do not match"
                                    })}
                                />
                                <small className="text-danger">{errors.confirmPassword && <p>{errors.confirmPassword.message}</p>}</small>
                            </div>
                        </div>

                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            data-dismiss="modal"
                            onClick={() => props.closeRemoveModal()}
                        >
                            {/* {props.context.t(
                            "STD-Employer-Statement.form.Employee-Details.Toggle.No.Common"
                        )} */}
                            Cancel
                        </button>
                        <button
                            // onClick={() => {
                            //     props.onYesClick();
                            // }}
                            type="submit"
                            className="btn btn-primary"
                        >
                            {/* {props.context.t(
                            "STD-Employer-Statement.form.Employee-Details.Toggle.Yes.Common"
                        )} */}
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </form>
    );
};
export default ConfirmationPasswordModalComponent;
